import { render } from "./ChangeCase.vue?vue&type=template&id=608d2924"
import script from "./ChangeCase.vue?vue&type=script&lang=js"
export * from "./ChangeCase.vue?vue&type=script&lang=js"
script.render = render

export default script